import React from 'react';

const SectionSelection = () => {
  return (
    <svg width="181" height="34" viewBox="0 0 181 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x=".5" y=".5" width="33" height="33" rx="7.5" fill="#F4F4F4" />
      <rect x=".5" y=".5" width="33" height="33" rx="7.5" stroke="#007E84" />
      <path d="m13.5 19.5 3.5-5 3.5 5h-7z" fill="#007E84" />
      <rect x="49.5" y=".5" width="33" height="33" rx="7.5" fill="#F4F4F4" />
      <rect x="49.5" y=".5" width="33" height="33" rx="7.5" stroke="#007E84" />
      <path d="m68.5 13.5-5 3.5 5 3.5v-7z" fill="#007E84" />
      <rect x="98.5" y=".5" width="33" height="33" rx="7.5" fill="#F4F4F4" />
      <rect x="98.5" y=".5" width="33" height="33" rx="7.5" stroke="#007E84" />
      <path d="m112.5 13.5 5 3.5-5 3.5v-7z" fill="#007E84" />
      <rect x="147.5" y=".5" width="33" height="33" rx="7.5" fill="#F4F4F4" />
      <rect x="147.5" y=".5" width="33" height="33" rx="7.5" stroke="#007E84" />
      <path d="m160.5 14.5 3.5 5 3.5-5h-7z" fill="#007E84" />
    </svg>
  );
};

export default SectionSelection;
